import React from "react";

const items = [
  {
    letter: "C",
    title: "Custody",
    body:
      "Who controls the relevant wallet, profile, asset, entitlement or evidence?",
    detail:
      "Members, patients, travellers, shipments, devices or role-controlled wallets hold evidence at source.",
  },
  {
    letter: "A",
    title: "Authority",
    body:
      "Who is allowed to request, approve, refuse, share, claim, hand off or escalate?",
    detail:
      "Parents, secretaries, clinicians, operators, customs roles and resilience officers act under policy.",
  },
  {
    letter: "R",
    title: "Receipts",
    body:
      "What proves the governed action happened — who acted, when, under what authority, what was shared and what was withheld?",
    detail:
      "A KATLAS-signed receipt with hash, signer, timestamp, verification, shared refs and withheld counts.",
  },
];

export const CarExplainer = () => {
  return (
    <section
      id="car"
      data-testid="section-car"
      className="relative py-24 lg:py-32 border-t border-white/[0.06]"
    >
      <div className="max-w-[1320px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="mono text-[10px] uppercase tracking-[0.3em] text-[#0066FF]">
              The CAR Pattern
            </div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl mt-4 leading-tight">
              Custody.
              <br />
              Authority.
              <br />
              <span className="text-[#EAB308]">Receipts.</span>
            </h2>
            <p className="mt-6 text-slate-400 text-sm leading-relaxed max-w-md">
              Custody controls the evidence. Authority governs the action.
              Receipts prove what happened.
            </p>
            <p className="mt-6 text-slate-500 text-xs leading-relaxed max-w-md italic border-l-2 border-[#0066FF]/40 pl-3">
              KATLAS records the governed action, not a copy of everyone's
              private data.
            </p>
          </div>

          <div className="lg:col-span-8 grid sm:grid-cols-3 gap-px bg-white/[0.06] border border-white/[0.06]">
            {items.map((it) => (
              <div
                key={it.letter}
                data-testid={`car-item-${it.title.toLowerCase()}`}
                className="bg-[#020B14] p-7 lg:p-8 flex flex-col"
              >
                <div className="flex items-baseline gap-3">
                  <span
                    className={`font-display text-5xl leading-none ${
                      it.title === "Receipts" ? "text-[#EAB308]" : "text-[#0066FF]"
                    }`}
                  >
                    {it.letter}
                  </span>
                  <span className="mono text-[10px] uppercase tracking-[0.2em] text-slate-500">
                    {it.title}
                  </span>
                </div>
                <div className="mt-6 font-display text-lg text-white">
                  {it.title}
                </div>
                <p className="text-sm text-slate-400 mt-2 leading-relaxed flex-1">
                  {it.body}
                </p>
                <div className="mt-6 pt-4 border-t border-white/[0.06]">
                  <p className="text-xs text-slate-500">{it.detail}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Operating principle row */}
        <div className="mt-12 grid sm:grid-cols-2 gap-px bg-white/[0.06] border border-white/[0.06]">
          <div className="bg-[#020B14] p-6">
            <div className="mono text-[10px] uppercase tracking-[0.2em] text-slate-500">
              Operating principle
            </div>
            <p className="mt-3 text-sm text-white leading-relaxed">
              AI suggests. Wallets prove. Authorised roles decide.{" "}
              <span className="text-[#EAB308]">KATLAS signs the receipt.</span>
            </p>
          </div>
          <div className="bg-[#020B14] p-6">
            <div className="mono text-[10px] uppercase tracking-[0.2em] text-slate-500">
              Data boundary
            </div>
            <p className="mt-3 text-sm text-white leading-relaxed">
              KATLAS records the governed action, not a copy of everyone's
              private data.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
